// eslint-disable-next-line import/no-cycle
import { getUserData } from '@/auth/utils'
import { USER_TYPE_STUDENT } from '@/const/userType'

export default function studentUsersOnly({ next, router }) {
  if (getUserData().usertype !== USER_TYPE_STUDENT && getUserData().usertype !== 'super') {
    return router.push('not-authorized')
  }

  return next()
}
